export async function checkoutRequest<T>(
  endpoint: "session" | "status",
  body: Record<string, string>
): Promise<T> {
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 30000);
  try {
    const response = await fetch(`/api/checkout/${endpoint}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify(body),
      signal: controller.signal,
    });
    const result = await response.json();
    if (!response.ok)
      throw new Error(
        typeof result.error === "string"
          ? result.error
          : "Checkout is temporarily unavailable. Your basket has been kept."
      );
    return result as T;
  } finally {
    window.clearTimeout(timeout);
  }
}

export function secureCheckoutUrl(value: unknown): string {
  if (typeof value !== "string")
    throw new Error("Secure checkout could not be opened. Please try again.");
  const url = new URL(value);
  if (
    url.protocol !== "https:" ||
    url.hostname !== "checkout.stripe.com" ||
    url.username ||
    url.password
  ) {
    throw new Error("Secure checkout could not be opened. Please try again.");
  }
  return url.href;
}
